// Pricing — Hybrid ladder. Built to grow a community AND honor the
// executive work. Voice: pastor-strategist. Warm authority, plain language,
// invitational. Benchmarked against Eric Thomas ($50K+ keynotes), Sarah
// Jakes (movement scale), Gary Vee (enterprise), Alicia Lyttle (programs
// $2K–$10K), Darius Daniels (leadership intensives), Marvin Golden (coaching).
// We sit a tier below ET/Sarah Jakes on price — deliberately — so the room
// stays full while the work stays premium.
// Prices and CTA destinations come from `src/content/offers.ts` — the single
// source of truth. Only marketing copy lives in this file.
import { OFFERS } from "@/content/offers";


export type PricingTier = {
  id: string;
  name: string;
  eyebrow: string;
  price: string;
  priceCadence?: string;
  description: string;
  benefits: string[];
  ctaLabel: string;
  ctaHref: string;
  featured?: boolean;
  badge?: string;
  socialProof?: string;
};

export const PRICING_TIERS: PricingTier[] = [
  {
    id: "circle",
    name: "MAKECHANGE Circle",
    eyebrow: "Start With Us",
    price: OFFERS.circle.priceLabel,
    priceCadence: OFFERS.circle.cadence,
    description:
      "A monthly room of builders, pastors, founders and operators walking the MAKECHANGE pillars together. Live calls, real questions, honest answers — not another content drop.",
    benefits: [
      "Monthly live call with Dr. Sully",
      "Members-only Q&A + replays",
      "MAKECHANGE worksheets each month",
      "Cancel anytime — no long contracts",
    ],
    ctaLabel: "Join the Circle",
    ctaHref: OFFERS.circle.href,
    socialProof: "Open enrollment · Founding-member pricing",
  },
  {
    id: "masterclass",
    name: "Built On Purpose Masterclass",
    eyebrow: "Go Deeper",
    price: OFFERS.masterclass.priceLabel,
    priceCadence: OFFERS.masterclass.cadence,
    description:
      "A 90-minute live masterclass plus lifetime replay. The MAKECHANGE Framework taught the way it lands in the room — practical, faith-honoring, and ready to use Monday morning.",
    benefits: [
      "Live 90-min teaching with Q&A",
      "Lifetime replay + companion workbook",
      "7-day implementation email series",
      "30 days inside the MAKECHANGE Circle",
    ],
    ctaLabel: "Enroll Now",
    ctaHref: OFFERS.masterclass.href,
    socialProof: "Avg 4.9★ from 200+ alumni",
  },
  {
    id: "coaching",
    name: "1:1 Executive Coaching",
    eyebrow: "By Application",
    price: OFFERS.coaching.priceLabel,
    priceCadence: OFFERS.coaching.cadence,
    description:
      "Confidential, high-velocity coaching for CEOs, founders, pastors and senior leaders. PsyD · ThD · DMin · CERC. Direct, faith-informed, and built around the work you're actually carrying.",
    benefits: [
      "Bi-weekly 60-min strategic 1:1s",
      "Voice-memo coaching between sessions",
      "Quarterly operating-rhythm reset",
      "Personalized MAKECHANGE playbook",
      "AI deployment + ethics guardrails",
    ],
    ctaLabel: "Apply for Coaching",
    ctaHref: OFFERS.coaching.href,
    featured: true,
    badge: "Most Requested",
    socialProof: "Selective intake · 8 seats / quarter",
  },
  {
    id: "enterprise",
    name: "Org Transformation + Keynote",
    eyebrow: "Enterprise",
    price: OFFERS.enterprise.priceLabel,
    priceCadence: OFFERS.enterprise.cadence,
    description:
      "Trauma-informed, equity-centered org transformation paired with a stage-ready keynote. The kind of engagement that outlasts the contract because the culture actually shifts.",
    benefits: [
      "Culture + leadership audit",
      "Systems redesign + 90-day roadmap",
      "Trauma-informed change management",
      "Signature keynote (in-person or virtual)",
      "Executive enablement + quarterly reviews",
    ],
    ctaLabel: "Request a Proposal",
    ctaHref: OFFERS.enterprise.href,
    socialProof: "Trusted by 100+ organizations",
  },
];
